Librarian.Modules.Opportunities = new Class({
    Extends: Librarian.Modules.Module,

    options: {
        classPrefix: "modules-opportunities-",
        title: "Opportunities",
        opportunityFilter: null, 

        /* metro tile settings */
        embedInModule: false,
        embedHeight: 303,
        openTabOnClick: false,
        tabName: "Opportunities"
    },

    opportunityFilter: null,
    className: "modules-opp",

    initialize: function(options, wrapperEl) {
        this.setOptions(options);
        var self = this;

        if (!this.options.opportunityFilter) {
            this.options.opportunityFilter = {};
        }

        this.opportunityFilter = Object.merge(this.options.opportunityFilter, this.getDefaultOpportunityFilter());
        
        if(this.options.embedInModule) {

            // get filter for homepage view
            this.opportunityFilter = {
                amount: 0,
                stageType: Librarian.crmStageType.active,
                orderByColumns: [{ name: "Score", order: Librarian.sortOrder.desc }],
                onHold: 0,
                keyword: '',
                state: Librarian.crmOpportunityState.active,
                dealStatus: Librarian.crmStageType.open,
                type: '',
                startRow: 1,
                maxRows: 3,
                viewName: null,
                fields: {},
                accountId: 0,
                flags: 0
            };

            this.options.height = this.options.embedHeight;

            if(this.options.openTabOnClick == true) {
                if(this.options.tabName) {
                    wrapperEl.addOnClick(function() {
                        Library.loadTabByName(self.options.tabName);
                    });
                } else {
                    wrapperEl.addOnClick(function() {
                        Library.loadTabByName("Opportunities");
                    });
                }
            }

        }

        this.parent(this.options, wrapperEl);
    },

    getDefaultOpportunityFilter: function() {
        return {
            amount: 0,
            stageType: Librarian.crmStageType.active,
            orderByColumns: [{ name: "Urgency", order: Librarian.sortOrder.desc }],
            onHold: 0,
            keyword: '',
            state: Librarian.crmOpportunityState.active,
            type: '',
            startRow: 1,
            maxRows: 2400,
            viewName: null,
            fields: {},
            accountId: 0,
            flags: 0
        };
    },

    load: function() {
        if (!this.wrapperEl)
            return;

        this.parent();

        if(this.options.class) {
            this.containerEl.addClass(this.options.class);
        }
        
        this.loadData();
    },

    loadData: function() {
        this.containerEl.empty();
        // Create the container element and generate the URL
        var parentContEl = new Element("div").injectInside(this.containerEl),
            // Get top opportunities
            url = Librarian.path.getCrmUrl("gettcros") + "&out=cjson&in=cjson";

        var oppFilter = JSON.stringify(Object.clone(this.opportunityFilter));
        if (typeof Base64 != "undefined")
            oppFilter = Base64.encode(oppFilter);

        this.request = new Librarian.Request.JSON({
            url: url,
            data: oppFilter,
            method: "post",
            onSuccess: function(opps) {
                parentContEl.empty();

                if (!opps || (opps.length == 0))
                    this.showNoOpp(parentContEl);
                else {
                    for (var i = 0, len = opps.length; i < len; i++)
                        this.buildOpportunityItem(opps[i], parentContEl);
                }
            }.bind(this),
            onFailure: Librarian.Utils.onFailure
        });
        this.request.send();
    },

    showNoOpp: function (parentContEl) {
        var className = this.className + "-no-item";
        parentContEl.addClass(className + "-wrapper");

        new Element("span", {
            "class": className + "-text",
            "text": Librarian.Lang.getString("modules_opportunities_none")
        }).injectInside(parentContEl);
    },

    buildOpportunityItem: function(opp, parentContainer) {

        if(this.options.embedInModule) {
           
            // build elements for each opportunity
            var oppItemEl = new Element("div", {
                "class": this.className + "-embed"
            });

            var oppItemName = new Element("div", {
                "class": this.className + "-name-embed", 
                "html": opp.accountName + ":"
            });

            var oppItemScore = new Element("div", {
                "class": this.className + "-score-embed"
            });

            // star rating based on score 0 - 100
            var numStars = parseInt(opp.score / 20);
            if(numStars > 5) {
                numStars = 5;
            }

            for(var i=0; i < numStars; i++) {
                var starEl = new Element("img", {
                    "class": this.className + "-score-star-embed", 
                    "src": Librarian.path.getLayoutsPath() + "/core/pagebuilder/images/star.png"
                });
                starEl.injectInside(oppItemScore);
            }

            // add halfstar
            if( (opp.score % 20 >= 10) && (numStars < 5) ) {
                var starEl = new Element("img", {
                    "class": this.className + "-score-star-embed", 
                    "src": Librarian.path.getLayoutsPath() + "/core/pagebuilder/images/half_star.png"
                });
                starEl.injectInside(oppItemScore);
            }

            // inject elements
            oppItemName.injectInside(oppItemEl);
            oppItemScore.injectInside(oppItemEl);
            oppItemEl.injectInside(parentContainer);
        }
        else {

            var className = this.className + "-item";

            //Container
            var oppItemEl = new Element("div", {
                "class": className,
                "id": className + "-" + opp.opportunityId
            }).injectInside(parentContainer);

            // Score
            var scoreContEl = new Element("div", {
                "class": className + "-score-cont",
                "styles": {
                    "border-color": this.getUrgencyColor(opp.urgency, opp.stageType)
                }
            }).injectInside(oppItemEl);
            new Element("span", {
                "class": className + "-score",
                "html": this.getScore(opp.stageType, opp.score)
            }).injectInside(scoreContEl);
            new Element("span", {
                "class": className + "-value",
                "html": this.getAmountString(opp.amount)
            }).injectInside(scoreContEl);      

            // Opportunity Name
            var infoContEl = new Element("div", {
                "class": className + "-info-cont pointer"
            }).injectInside(oppItemEl);
            new Element("span", {
                "class": className + "-name ellipsis",
                "title": opp.name,
                "html": opp.name
            }).injectInside(infoContEl);

            infoContEl.addOnClick(function() { this.openProjectRoom(opp.opportunityId); }, this);
        }
    },

    getScore: function(stageType, score) {
        return ((stageType == Librarian.crmStageType.closedWon) || (stageType == Librarian.crmStageType.closedLost)) ? "---" : parseInt(score, 10);
    },

    getUrgencyColor: function(urgency, stageType) {
        if (stageType == Librarian.crmStageType.closedWon)
            return "#82BD3D";
        if (stageType == Librarian.crmStageType.closedLost)
            return "#333";
        if (urgency >= 80)
            return "#D2254B";
        if (urgency >= 60)
            return "#F5821E";
        if (urgency >= 40)
            return "#F4CD42";
        return "#0078BE";
    },

    getAmountString: function(amount) {
        if (amount > 0 && amount < 1000)
            return "$" + amount;
        if (amount >= 1000 && amount < 1000000)
            return "$" + parseInt(amount / 1000, 10) + "K";
        if (amount >= 1000000 && amount < 1000000000)
            return "$" + parseInt(amount / 1000000, 10) + "M";
        if (amount > 1000000000 && amount < 1000000000000)
            return "$" + parseInt(amount / 1000000000, 10) + "B";
        if (amount > 1000000000000 && amount < 1000000000000000)
            return "$" + parseInt(amount / 1000000000000, 10) + "T";
        return "---";
    },

    openProjectRoom: function(oppId) {
        var url = Librarian.path.getAppPath("dashboard") + "/project.htm?libName=" + Librarian.path.getUrlLibraryName();
        if (url.indexOf('?') == -1)
            url += '?';
        else
            url += '&';
        window.open(url + "oppId=" + oppId, "Project" + oppId, "width=990,height=770");
    }
});